import { render, staticRenderFns } from "./SettlementStatusBadge.vue?vue&type=template&id=e2cb8280&scoped=true"
import script from "./SettlementStatusBadge.vue?vue&type=script&lang=js"
export * from "./SettlementStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./SettlementStatusBadge.vue?vue&type=style&index=0&id=e2cb8280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cb8280",
  null
  
)

export default component.exports